import collect from 'collect.js';

export default {
  methods: {
    updateThemeColor(key, value) {
      if (key && value) {
        this.$vuetify.theme.themes.light[key] = value;
        this.$vuetify.theme.themes.dark[key] = value;
      }
    },
    addStyleClass(rules) {
      if (rules.length > 0) {
        const style = document.createElement('style');
        document.head.appendChild(style);

        style.sheet.insertRule(rules.join('\n'), style.sheet.cssRules.length);
      }
    },
  },
  created() {
    if (this.$gd) {
      collect(this.$gd.color()).each((value, key) => {
        this.updateThemeColor(key, value);
      });
      collect(this.$gd.extraColors()).each((value, key) => {
        this.updateThemeColor(key, value);
      });
      this.addStyleClass(this.$gd.getDefaultColorRules());
    }
  },
}
